import { render, staticRenderFns } from "./promotion-allocation-area.vue?vue&type=template&id=408c9914&scoped=true"
import script from "./promotion-allocation-area.vue?vue&type=script&lang=js"
export * from "./promotion-allocation-area.vue?vue&type=script&lang=js"
import style0 from "./promotion-allocation-area.vue?vue&type=style&index=0&id=408c9914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c9914",
  null
  
)

export default component.exports